import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent implements OnInit {
  title = 'Glamera Registration';

  constructor(
    private spinner : NgxSpinnerService
  ) {

  }
  ngOnInit() {
    console.log('app component init');
    if (!localStorage.getItem('lang')) { localStorage.setItem('lang', 'ar') }
    if (!localStorage.getItem('dir')) { localStorage.setItem('dir', 'rtl') }

    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }

}
